var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('big-round-button',{attrs:{"color":"secondary","height":_vm.height,"width":_vm.width,"to":"/addIssue","icon":"mdi-email-outline","text":"ΑΙΤΗΜΑ"}})}
var staticRenderFns = []

export { render, staticRenderFns }